// extracted by mini-css-extract-plugin
export var tableActions = "styles-module--table-actions--14209";
export var tableActionsButton = "styles-module--table-actions-button--95e18";
export var tableActionsSearch = "styles-module--table-actions-search--cbe51";